export enum LoginType {
	USER = 'user',
	ORGANIZATION = 'organization',
}

export enum LoginStep {
	LOGIN = 'login',
	REGISTER = 'register',
}

export enum DiscussionListType {
	PARTICIPANT,
	VIEWER,
}
